import { defHttp } from '@/axios/http'

/**
 * 登陆
 */
export const login = (data: {
  account: string
  password: string
  gaptchaCode?: string
}) => {
  return defHttp.post({ url: '/doLogin', data },{'rsa_encrypt_show':true})
}

/**
 * 验证码
 */
export const getGaptcha = (val: string) => {
  return defHttp.get({
    url: '/authCode',
    params: { t: new Date().getTime(), type: val },
    responseType: 'blob',
  })
}

/**
 * 获取线段干扰的验证码
 */
export const getGaptchaLine = () => {
  return defHttp.get({
    url: '/captcha/line',
  }, { baseAxiosURL: '/public'} )
}
/**
 * 验证线段干扰的验证码
 */
export const GaptchaVerify = (data: any) => {
  return defHttp.post({
    url: '/captcha/verify',
    data,
  }, { baseAxiosURL: '/public'})
}

/**
 * 退出登陆
 */
export const logout = () => {
  return defHttp.get({ url: '/logout' })
}

/**
 * 忘記密碼
 */
export const forgetPassword = (data: {
  userName?: string
  email: string
  account?: string
  gaptchaCode?: string
}) => {
  return defHttp.post({ url: '/user/forgetPassword', data })
}

/**
 * 修改密碼
 */
export const updatePassword = (data: {
  oldPassword: string
  newPassword: string
  confirmPassword: string
  gaptchaCode?: string
}) => {
  return defHttp.post({ url: '/user/updatePassword', data },{'rsa_encrypt_show':true})
}

/**
 * 主题列表
 */
export const findAdvertB = () => {
  return defHttp.get({ url: '/public/themes' }, { baseAxiosURL: '' })
}
/**
 * 产品服务
 */
export const findAdvertC = () => {
  return defHttp.get({ url: '/public/product/services' }, { baseAxiosURL: '' })
}

/**
 * 公司业务
 */
export const companyDropdown = () => {
  return defHttp.get({ url: '/public/comp/biz/dropdown' }, { baseAxiosURL: '' })
}

/**
 * 提交联系我们form
 */
export const pushQuotation = (data) => {
  return defHttp.post({ url: '/public/biz/pushQuotation', data }, { baseAxiosURL: '' })
}


/**
 * 资讯信息
 */
export const getInformation = (category) => {
  return defHttp.get({ url: '/public/information/' + category }, { baseAxiosURL: '' })
}

/**
 * 查詢當前登錄用戶可訪問的系統列表
 */
export const findSysSystemList = () => {
  return defHttp.get({ url: '/systems' })
}
/**
 * 查詢當前登錄用戶的公司
 */
export const selectCompByUserId = (params?: any) => {
  return defHttp.post({ url: '/selectCompByUserId', params })
}
/**
 * 查詢文件列表
 */
export const findSysFileList = (data: any) => {
  return defHttp.post({ url: '/files', data })
}
/**
 * 文件来源下拉框
 */
export const getFileSource = () => {
  return defHttp.get({ url: '/file/source/dropdown' })
}
/**
 * 下载文件
 */
export const downloadFile = (params: { fileName: string }) => {
  return defHttp.post({
    url: '/downloadFile',
    params,
    responseType: 'blob',
  });
};
/**
 * 套餐权限配置-列表查询
 */
export const getRolePlanList = (params:any) => {
  return defHttp.post({
    url: '/rolePlan/list',
    params,
  });
};
/**
 * 套餐权限查询
 */
export const getPlanList = () => {
  return defHttp.post({
    url: '/plan/list'
  });
};
/**
 * 套餐权限配置-修改
 */
export const updateRolePlan = (params:any) => {
  return defHttp.post({
    url: '/rolePlan/update',
    params,
  });
};
/**
 * 重置密碼
 */
export const resetPassword = (data:any) => {
  return defHttp.post({
    url: '/user/resetPassword',
    data,
  },{'rsa_encrypt_show':true});
};


/**
 * 重置密碼
 */
export const getAuthCode = (data:any) => {
  return defHttp.get({
    url: '/authCode',
    data,
  });
};

/**
 * 清空广告区缓存信息
 */
export const advertClear = (data?:any) => {
  return defHttp.get({
    url: '/advert/clear',
    data,
  });
};



/**
 * 跳转其他项目
 */
export const generateToken = (code:string) => {
  return defHttp.get({
    url: '/generateToken/'+code,
  });
};

// 获取用户平台权限
export const getFindSystem = (userId:any) => {
  return defHttp.get({
    url: '/findSystem/'+userId,
  });
};
// 保存用户平台权限
export const setFindSystem = (data:any) => {
  return defHttp.post({
    url: '/system/editUserSystem',
    data
  });
};
// 获取所有平台系统
export const getSystemList = () => {
  return defHttp.get({
    url: '/system/findAll',
  });
};
// 蓝色平台登录
export const sshLogin = (data?:any) => {
  return defHttp.post({
    url: '/sshLogin',
    data
  });
};

// 蓝色平台登录
export const checkPolarUserResetPwd = (params?:any) => {
  return defHttp.get({
    url: '/checkPolarUserResetPwd',
    params
  });
};
// 模拟登录
export const simulateLogin = (account:string) => {
  return defHttp.post({
    url: `/login/simulate?account=${account}`,
  });
};
// 查询账号是否被模拟登录
export const simulateLoginStatus = (account:string) => {
  return defHttp.get({
    url: '/login/simulate/status/' + account
  });
};